import { render, staticRenderFns } from "./guest.vue?vue&type=template&id=b6055a10&scoped=true&"
import script from "./guest.vue?vue&type=script&lang=js&"
export * from "./guest.vue?vue&type=script&lang=js&"
import style0 from "./guest.vue?vue&type=style&index=0&id=b6055a10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6055a10",
  null
  
)

export default component.exports